import React from "react";
import Link from "@mui/material/Link";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

const Anchor = ({ text, onClick }) => (
    <Link
        sx={{
            cursor: "pointer",
            textDecoration: "none",
            color: theme => theme.palette.text.primary,
            "&:hover": {
                color: theme => theme.palette.text.primary
            }
        }}
        onClick={onClick}
    >
        <Typography variant="caption" sx={{ color: theme => theme.palette.primary.main }}>
            {text}
        </Typography>
    </Link>
);

Anchor.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};

export default Anchor;
